import React from 'react';
import { Tag, Tooltip, Popover, Button } from 'antd';

export default [
  {
    title: 'Name',
    dataIndex: 'name'
  },
  {
    title: 'Client Key',
    dataIndex: 'clientKey',
    render: clientKey => (
      <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <span
          style={{
            display: 'inline-block',
            width: '100%',
            maxWidth: 180,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
          }}
        >
          {clientKey}
        </span>

        <div onClick={e => e.stopPropagation()}>
          <Popover
            trigger="click"
            content={<div style={{ maxWidth: 300, wordBreak: 'break-all' }}>{clientKey}</div>}
          >
            <Button
              type="link"
              size="small"
              onClick={e => e.stopPropagation()}
              style={{ padding: 0 }}
            >
              Show
            </Button>
          </Popover>
        </div>
      </div>
    )
  },
  {
    title: 'Client Secret',
    dataIndex: 'clientSecret',
    render: clientSecret => (
      <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <span
          style={{
            display: 'inline-block',
            width: '100%',
            maxWidth: 300,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
          }}
        >
          {clientSecret}
        </span>
        <div onClick={e => e.stopPropagation()}>
          <Popover
            trigger="click"
            content={<div style={{ maxWidth: 300, wordBreak: 'break-all' }}>{clientSecret}</div>}
          >
            <Button
              type="link"
              size="small"
              onClick={e => e.stopPropagation()}
              style={{ padding: 0 }}
            >
              Show
            </Button>
          </Popover>
        </div>
      </div>
    )
  },
  {
    title: 'Active',
    dataIndex: 'isActive',
    render: isActive => <span>{isActive ? 'Yes' : 'No'}</span>
  },
  {
    title: 'Rate Limit / minute',
    dataIndex: 'rateLimit'
  }
  // {
  //   title: 'Scopes',
  //   dataIndex: 'allowedScopes',
  //   render: scopes => (
  //     <>
  //       <div>
  //         <Tag color="blue">{scopes[0]}</Tag>
  //         {scopes.length > 1 && (
  //           <Tooltip
  //             placement="bottom"
  //             title={
  //               <div style={{ padding: '10px 5px' }}>
  //                 {scopes.map(scope => (
  //                   <Tag
  //                     color="blue"
  //                     key={scope}
  //                     style={{ marginBottom: '5px', display: 'block', minWidth: '100%' }}
  //                   >
  //                     {scope}
  //                   </Tag>
  //                 ))}
  //               </div>
  //             }
  //           >
  //             <span style={{ cursor: 'pointer', color: '#1890ff' }}>+{scopes.length - 1} more</span>
  //           </Tooltip>
  //         )}
  //       </div>
  //     </>
  //   )
  // }
];
